import React, {useContext, useEffect, useRef, useState} from "react";
import {Navigation} from "swiper/modules";
import {Swiper, SwiperRef, SwiperSlide} from "swiper/react";
import "./blog-section.scss";
import {DeviceContext, DeviceContextState} from "../../shared/services/device-context/device-context";
import {DeviceType} from "../../shared/services/device-context/device-context-vars";
import {useNavigate} from "react-router-dom";
import axios, { AxiosResponse } from "axios";
import {SERVER_URL, SERVER_DOMAIN_URL, BLOG_API_PATH} from "../../../global_vars";

interface BlogData {
  main_image_url: string;
  title: string;
  title_slug: string;
  description: string;
}

interface BlogListResponse {
code: number;
msg: string;
data: BlogData[];
}

function BlogSection() {
  const swiperRef = useRef<SwiperRef>(null);
  const [blogs, setBlogs] = useState<BlogData[]>([]);

  const device: DeviceContextState  = useContext(DeviceContext);

  const navigate = useNavigate();

  const navigateToURL = (url: string) => {
    navigate(`/${url}`);
  }

  useEffect(() => {
    axios.get(`${SERVER_URL}${BLOG_API_PATH}/list?page_num=1`).then((res: AxiosResponse<BlogListResponse>) => {
      if (res.data.code !== 200) {
        console.log("unable to fetch featured properties");
        return;
      }
      console.log(res.data.data);
      setBlogs(res.data.data);
    }).catch((err) => {
      console.log(err);
    })
  }, []);


    return (
        <div className="blog-section">
            <div className="blog-section-heading">
              <h2>RECENT DUBAI REAL ESTATE BLOGS</h2>
              {/* <h5>BE THE FIRST TO KNOW ABOUT RECENT DEVELOPMENTS AND VENTURES</h5> */}
              <p>Get insights on latest trends and high value returned properites</p>
              <hr style={{
              width: "90%",
              border: "0.5px solid #A3A3A3",
            }} />
            </div>

            

            

            <Swiper
                ref={swiperRef}
                modules={[Navigation]}
                className={"blog-carousel"}
                slidesPerView={device.deviceType === DeviceType.DESKTOP ? 2 : 1}
                speed={1000}
                cssMode={true}
                navigation={{
                  nextEl: ".blog-button-next",
                  prevEl: ".blog-button-prev",
                }}
            >
                {
                    blogs.map((blog: BlogData, index: number) => (
                        <SwiperSlide key={index} className={"blog-slide"}>
                        <div className={"blog-card"}>
                        <a href={"/blog/" + blog.title_slug} className="blog-card-link">
                          <div className={"blog-image-container"}>
                            <img className={"blog-card-image"} src={blog.main_image_url}></img>
                          </div>
                            <div className={"blog-details"}>
                                <h2 className={"blog-heading"}>{blog.title}</h2>
                                <p className={"blog-description"}>{blog.description}</p>
                            </div>
                          </a>
                        </div>
                        </SwiperSlide>
                    ))
                }
                
            </Swiper>

            <div className={"blog-header"}>
                <div className="blog-navigation-buttons">
                  <button className="blog-button-prev">
                    <i className="bi bi-chevron-left"></i>
                  </button>
                  <button className="blog-button-next">
                    <i className="bi bi-chevron-right"></i>
                  </button>
                </div>
                <div className={"view-blogs"}>
                  <a className={"view-blogs-btn"} href={`${SERVER_DOMAIN_URL}/blog/list?page_num=1`}>EXPLORE BLOGS</a>
                </div>
            </div>
        </div>
    )
}

export default BlogSection;